import React from 'react';
import styled from 'react-emotion';
import groupBy from './groupBy';
export const Region = ({ channels, render }) => {
    const groupedCountries = groupBy(channels, channel => channel.region);
    return (React.createElement(RegionWrapper, null, Object.keys(groupedCountries).map(region => {
        const regionCountries = groupedCountries[region];
        return render({ regionCountries, region });
    })));
};
export default Region;
export const RegionName = styled('h2') `
  text-transform: uppercase;
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 600;
  margin: 1rem 0 0.5rem 0;
`;
export const RegionWrapper = styled('div') ``;
export const RegionGroup = styled('div') ``;
//# sourceMappingURL=Region.js.map